import { render, staticRenderFns } from "./Refund.vue?vue&type=template&id=47f247e8&scoped=true"
var script = {}
import style0 from "./Refund.vue?vue&type=style&index=0&id=47f247e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f247e8",
  null
  
)

export default component.exports